import { render, staticRenderFns } from "./doQuestionRecordSeven.vue?vue&type=template&id=4d4b862c&scoped=true"
import script from "./doQuestionRecordSeven.vue?vue&type=script&lang=js"
export * from "./doQuestionRecordSeven.vue?vue&type=script&lang=js"
import style0 from "./doQuestionRecordSeven.vue?vue&type=style&index=0&id=4d4b862c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4b862c",
  null
  
)

export default component.exports